/** Constantes globales partagées par la sim et le rendu. */

/** Pas de temps fixe de la simulation, en secondes. Jamais de delta variable dans la physique. */
export const FIXED_DT = 1 / 60;

/** Même pas, en millisecondes (pour l'accumulateur de la boucle temps-réel). */
export const FIXED_DT_MS = 1000 / 60;

/** Clamp anti « spirale de la mort » : on n'avale jamais plus de 250 ms d'un coup. */
export const MAX_FRAME_DELTA_MS = 250;

/** Dimensions du monde / canvas (px). Aligné sur le viewport Playwright. */
export const WORLD_WIDTH = 1280;
export const WORLD_HEIGHT = 720;

// Les dimensions du corps des véhicules vivent désormais dans le registre `src/sim/vehicles.ts`
// (une voiture choisit un type via `vehicle`), plus de constantes CAR_WIDTH/CAR_HEIGHT globales.

/** Le mode test (hook window.__game, sim découplée du rAF) est activé par ?test=1. */
export function isTestMode(): boolean {
  return typeof location !== 'undefined' && new URLSearchParams(location.search).has('test');
}
